module.exports = __webpack_public_path__ + "static/media/image4.30be40ac.jpg";